import { Suspense, lazy, useMemo } from "react";
import { jsx } from "react/jsx-runtime";
import { SuspenseFallback } from "@tecnobit-srl/components-store";
//#region src/use-carousel.tsx
var LazyCarousel = lazy(() => import("./carousel-Codt5Yl_.js").then((n) => n.n).then((module) => ({ default: module.Carousel })));
function Carousel({ ...props }) {
	return /* @__PURE__ */ jsx(Suspense, {
		fallback: /* @__PURE__ */ jsx(SuspenseFallback, { name: "carousel" }),
		children: /* @__PURE__ */ jsx(LazyCarousel, { ...props })
	});
}
function CarouselContent({ ...props }) {
	return /* @__PURE__ */ jsx(Suspense, {
		fallback: /* @__PURE__ */ jsx(SuspenseFallback, { name: "carousel" }),
		children: /* @__PURE__ */ jsx(LazyCarousel, { ...props })
	});
}
var useCarouselContent = () => {
	return useMemo(() => ({ carousel: { component: CarouselContent } }), []);
};
//#endregion
export { Carousel, useCarouselContent };
